// extracted by mini-css-extract-plugin
var _1 = "TablePaginationNavigation-moduletablePaginationNavigation__g1mC0";
export { _1 as "tablePaginationNavigation" }
